import React from 'react';
import type { Root } from 'react-dom/client';
import { createRoot } from 'react-dom/client';

import { CookieBanner } from './CookieBanner';

export const renderCookieBannerInShadowRoot = (shadowRoot: ShadowRoot): Root => {
    const mountPoint = document.createElement('div');
    // The settings modal would otherwise render into document.body, outside the shadow root's styles.
    const modalContainer = document.createElement('div');
    shadowRoot.append(mountPoint, modalContainer);

    const root = createRoot(mountPoint);
    root.render(<CookieBanner floating modalContainer={modalContainer} />);
    return root;
};
